module.exports = __webpack_public_path__ + "img/Embers-Adrift-2022-007.ce20197a.jpg";